import {
  observable,
  computed,
  action
} from 'mobx'
export default class fwMobileView {
  @observable pageShowMethod = 'continuousPage'
  @observable mobilePrintFunction = null
  @observable showFile = false
  @observable organizePage = false
  @observable outlineShowMethod = "bookMark"
  @observable openAddPagePopup = false
  

  @action setPageShowMethod(val) {
    this.pageShowMethod = val
  }
  @action setShowFile(showFile) {
    this.showFile = showFile
  }
  @action setOutlineShowMethod(outlineShowMethod) {
    this.outlineShowMethod = outlineShowMethod
  }
  @action setOpenAddPagePopup(openAddPagePopup) {
    this.openAddPagePopup = openAddPagePopup
  }

  @computed get isIOS() {
    var USER_AGENT = navigator.userAgent.toLowerCase();
    let isIOS = /ipad|iphone|ipod/.test(USER_AGENT);
    return isIOS
  }
  @computed get isWechatOrQQBuild() {
    const ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
      return "weixin";
    } else if (ua.match(/QQ/i) == "qq") {
      return "QQ";
    } else if (ua.indexOf("baidu") > 0) {
      return "baidu"
    } else {
      return false;
    }
  }

  // 获取页面的注释信息
  @action loadAnnots(pageIndex) {
    // return window.pdfui
    return window.pdfui.getCurrentPDFDoc()
    .then(doc => {
        if (!doc) return null;
        return doc.getPageAnnots(pageIndex).then(annots => {
          return this.getAnnotsInkInfo(annots)
        });
    });
  }
  // 注释信息的处理
  @action getAnnotsInkInfo = (annots) => {
    let inkArr = []
    annots.length>0 && console.log(annots)
    inkArr = annots.filter((annot) => {
      return annot.getType() !== "popup" && annot.getType() !== "link" 
    })
    inkArr = inkArr.filter((annot,index) => {
      return annot.getType() !== "text" || (annot.getType() === "text" && annots[index+1] && annots[index+1].getType() === "popup")
    })
    return inkArr
  }
}
